import { render, staticRenderFns } from "./requestMuatDetail.vue?vue&type=template&id=73f788c0"
import script from "./requestMuatDetail.vue?vue&type=script&lang=js"
export * from "./requestMuatDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports